import { entorno, etiquetaAmbiente } from '@/lib/entorno'
import { useSesion } from '@/modules/auth/useSesion'
import { CampanaAvisos } from '@/modules/avisos/CampanaAvisos'
import { Boton } from '@/shared/ui/Boton/Boton'
import { NOMBRE_ROL } from '@/shared/dominio/roles'
import { iniciales } from '@/shared/utilidades/formato'

import estilos from './BarraSuperior.module.css'

type PropsBarraSuperior = {
  titulo: string
  /** Migaja de contexto: en qué parte del recorrido está la pantalla. */
  contexto?: string
  /** Sin esto no se dibuja el botón: el técnico no tiene menú que abrir. */
  onAbrirMenu?: () => void
}

export function BarraSuperior({ titulo, contexto, onAbrirMenu }: PropsBarraSuperior) {
  const { perfil, salir } = useSesion()

  return (
    <header className={`${estilos.barra} no-imprimir`}>
      <div className={estilos.izquierda}>
        {onAbrirMenu && (
          <button
            type="button"
            className={estilos.cajon}
            onClick={onAbrirMenu}
            aria-label="Abrir el menú"
          >
            ☰
          </button>
        )}

        {/* Con clase y no suelto: es este envoltorio —y no el <h1> de adentro—
            el que tiene que poder encogerse en un teléfono. Sin un ancho
            mínimo de cero se quedaba con el ancho entero del título y lo
            metía por debajo de la insignia de ambiente. */}
        <div className={estilos.tituloZona}>
          {contexto && <p className={estilos.ruta}>{contexto}</p>}
          <h1 className={estilos.titulo}>{titulo}</h1>
        </div>
      </div>

      <div className={estilos.derecha}>
        {/* Solo en la máquina de quien desarrolla. Estaba saliendo en todo lo
            desplegado, y una insignia que dice «PRUEBAS» delante del cliente
            resta más de lo que protege: para MEGA todo lo que ve es el
            sistema, no un ensayo. */}
        {entorno.ambiente === 'local' && (
          <span className={estilos.ambiente} title="Este NO es el ambiente productivo.">
            {etiquetaAmbiente[entorno.ambiente]}
          </span>
        )}

        {perfil && <CampanaAvisos />}

        {/* LA IDENTIDAD SE FUE AL PIE DEL MENÚ, que es donde la esperan y donde
            además tapa el hueco que dejaba el riel al terminarse los enlaces.
            Aquí solo se queda para el operario: él no tiene menú lateral —una
            sola pantalla no necesita menú— y sin esto se quedaría sin ninguna
            forma de salir. */}
        {perfil && perfil.rol === 'operario' && (
          <>
            <div className={estilos.usuario}>
              <span className={estilos.avatar} aria-hidden="true">
                {iniciales(perfil.nombre)}
              </span>

              <div className={estilos.datosUsuario}>
                <p className={estilos.nombre}>{perfil.nombre}</p>
                <p className={estilos.rol}>{NOMBRE_ROL[perfil.rol]}</p>
              </div>
            </div>

            <Boton variante="plano" tamano="pequeno" onClick={() => void salir()}>
              Salir
            </Boton>
          </>
        )}
      </div>
    </header>
  )
}
